import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";
import { getLocalPosition } from "./LocalPosition";

// Returns the position of the closets to the local position marker
export function closestMarker(localPosition, markersReference) {
    let distance = 0;
    let closest = 0;
    // We are converting the local position in a LatLng object as the
    // 'computeDistanceBetween' methond forks only with LatLng objects.
    let localLnatLng = new window.google.maps.LatLng(localPosition.lat, localPosition.lng);

    for (let i = 0; i < markersReference.length; i++) {
        let d = window.google.maps.geometry.spherical.computeDistanceBetween(
            markersReference[i].position,
            localLnatLng
        );
        if (i === 0 || d < distance) {
            distance = d;
            closest = i;
        }
    }
    // We are clearing the closest marker as we are going
    // to have a pin on its place from the drawed route.

    let closestPosition = markersReference[closest].position;
    markersReference[closest].setMap(null);
    markersReference.splice(closest, 1);

    return closestPosition;
}

// Get the current location of the device the application is run on
export function drawRouteFromLocation(params) {
    return new Promise((resolve, reject) => {
        let directions = params.directions;
        let waypoints = directions.waypoints;
        let end = directions.end;
        let errorMessages = params.errorMessages;
        let markersReference = params.markersReference;
        let apiKey = params.apiKey;

        getLocalPosition(errorMessages, apiKey).then(
            response => {
                if (!directions.end) {
                    end = closestMarker(response, markersReference);
                }

                drawRoute(
                    params.map,
                    {
                        start: response,
                        end: end || "",
                        waypoints: waypoints,
                        mode: directions.mode
                    },
                    errorMessages,
                    params.directionsDisplayRef
                ).then(response => {
                    resolve(response);
                });
            },
            error => {
                WEBUILogs.error(error);
                resolve(false);
            }
        );
    });
}

//Initializing / Drawing the directions service and drawing the route.
export function drawRoute(map, directions, errorMessages, directionsDisplayRef) {
    //We return a promise so we know when the callback from the directions service has completed.
    return new Promise((resolve, reject) => {
        // If the start and end point of the already existing route are the same,
        // we just resolve the promise with the same route object and return from the function.
        if (
            JSON.stringify(directionsDisplayRef.start) === JSON.stringify(directions.start) &&
            JSON.stringify(directionsDisplayRef.end) === JSON.stringify(directions.end)
        ) {
            resolve({
                routed: true,
                directionsDisplayRef: {
                    directionsDisplay: directionsDisplayRef.directionsDisplay,
                    start: directionsDisplayRef.start,
                    end: directionsDisplayRef.end
                }
            });
            return;
        }
        // If either the start or end point is different we clear the existing route,
        // because we want to draw a new one.
        if (
            directionsDisplayRef.start &&
            (JSON.stringify(directionsDisplayRef.start) !== JSON.stringify(directions.start) ||
                JSON.stringify(directionsDisplayRef.end) !== JSON.stringify(directions.end))
        ) {
            directionsDisplayRef.directionsDisplay.setMap(null);
        }

        let directionsService = new window.google.maps.DirectionsService();
        let directionsDisplay = new window.google.maps.DirectionsRenderer();
        let waypoints = [];
        let directionWaypoints = directions.waypoints ? directions.waypoints : [];

        for (let j = 0; j < directionWaypoints.length; j++) {
            waypoints.push({
                //The API requires the middle way points to be objects with 2 properties.
                location: directions.waypoints[j],
                stopover: true
            });
        }

        directionsDisplay.setMap(map);
        directionsService.route(
            //We are making the request to the server sending the following information:
            {
                origin: directions.start, //Start way point.
                destination: directions.end, //End way point.
                waypoints: waypoints, //Middle way points.
                travelMode: directions.mode || "DRIVING"
            },
            function(response, status) {
                if (status === "OK") {
                    directionsDisplay.setDirections(response);
                    //The request has succeeded so we resolve the promise knowing the route drawing is completed.
                    resolve({
                        routed: true,
                        directionsDisplayRef: {
                            directionsDisplay: directionsDisplay,
                            start: directions.start,
                            end: directions.end
                        }
                    });
                } else {
                    WEBUILogs.error(errorMessages.directionsError, status);
                    resolve({
                        routed: false,
                        directionsDisplayRef: {}
                    });
                }
            }
        );
    });
}

export function clearRouteBeforeResponse(drawRouteFlag, directionsDisplayRef) {
    if (!drawRouteFlag && directionsDisplayRef.hasOwnProperty("directionsDisplay")) {
        directionsDisplayRef.directionsDisplay.setMap(null);
        return {};
    }

    return directionsDisplayRef;
}
